import CancelIcon from '~/assets/icons/cancel-icon-indicador.png';

export const modalInativar = {
  html: `<div>
      <div class="headerModalIndicador">
      <img src=${CancelIcon} />
      <h2><span>Inativar </span>instituição?</h2></div>
      <div class="bodyModalIndicador">
      <p>

      Ao inativar uma instituição, todos os seus usuários perderão acesso ao sistema. Deseja prosseguir?

      </p>
      </div></div>`,
  showCancelButton: true,
  confirmButtonColor: '#cc0000',
  cancelButtonColor: '#FFF',
  confirmButtonText: 'Inativar instituição',
  cancelButtonText: 'Cancelar',
  customClass: {
    container: 'container-modal-switch-indicadores',
    confirmButton: 'confirm-button-switch-indicadores',
    cancelButton: 'cancel-button-switch-indicadores',
  },
};

export const alertLogoSuccess = {
  title: 'Sucesso!',
  text: `O logotipo da instituição foi enviado com sucesso!`,
  icon: 'success',
  confirmButtonColor: '#74a50a',
  confirmButtonText: 'Ok! Obrigado!',
};

export const alertSaveUpload = {
  title: 'Atenção!',
  text:
    'Apenas o logotipo da instituição é alterável, selecione a imagem e tente novamente.',
  icon: 'warning',
  confirmButtonColor: '#74a50a',
};
